import client from "../api/client";

/**
 * Direct API call — no more Cloud Function proxy.
 */
export async function apiCall(
  path: string,
  options?: {
    method?: string;
    body?: any;
    query?: Record<string, string>;
  }
): Promise<Response> {
  const config: any = {
    method: (options?.method || "GET").toLowerCase(),
    url: path,
    params: options?.query,
  };

  if (options?.body && options.method !== "GET") {
    config.data = options.body;
  }

  const res = await client.request(config);
  // Return a Response-like object for backward compatibility
  return new Response(JSON.stringify(res.data), {
    status: res.status,
    headers: { "Content-Type": "application/json" },
  });
}

/**
 * Upload file directly to API.
 */
export async function apiUpload(
  path: string,
  formData: FormData
): Promise<Response> {
  const res = await client.post(path, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return new Response(JSON.stringify(res.data), {
    status: res.status,
    headers: { "Content-Type": "application/json" },
  });
}

/**
 * cfCall removed — Cloud Functions no longer needed.
 * Use apiCall instead.
 */
export const cfCall = apiCall;
